module.exports = __webpack_public_path__ + "/login_ui/img/pt-bd78d5617f3f892ab6eb0acf94daa174.svg";